class CartNote extends HTMLElement {
  #activeFetch = null;
  #debounceTimer = null;

  connectedCallback() {
    const textarea = this.querySelector('textarea');
    if (textarea) {
      textarea.addEventListener('input', this.updateCartNote);
      textarea.addEventListener('blur', this.flushCartNote);
    }
  }

  disconnectedCallback() {
    const textarea = this.querySelector('textarea');
    if (textarea) {
      textarea.removeEventListener('input', this.updateCartNote);
      textarea.removeEventListener('blur', this.flushCartNote);
    }
  }

  updateCartNote = (event) => {
    if (!(event.target instanceof HTMLTextAreaElement)) return;
    clearTimeout(this.#debounceTimer);
    const note = event.target.value;
    this.#debounceTimer = setTimeout(() => this.#sendNote(note), 200);
  };

  flushCartNote = (event) => {
    if (!(event.target instanceof HTMLTextAreaElement)) return;
    clearTimeout(this.#debounceTimer);
    this.#sendNote(event.target.value);
  };

  async #sendNote(note) {
    if (this.#activeFetch) {
      this.#activeFetch.abort();
    }

    const abortController = new AbortController();
    this.#activeFetch = abortController;

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note }),
        signal: abortController.signal,
        keepalive: true,
      });
    } catch (error) {
      // Rapid typing/navigating aborts in-flight requests — expected, ignore.
    } finally {
      this.#activeFetch = null;
    }
  }
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote);
}